import { render, staticRenderFns } from "./TeamAvatars.vue?vue&type=template&id=34a45e46&scoped=true"
import script from "./TeamAvatars.vue?vue&type=script&lang=js"
export * from "./TeamAvatars.vue?vue&type=script&lang=js"
import style0 from "./TeamAvatars.vue?vue&type=style&index=0&id=34a45e46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a45e46",
  null
  
)

export default component.exports